import React from "react";
import Select, { components } from "react-select";
import { HiOutlineArrowUp } from "react-icons/hi";
import apColorConfig from "../theme/APColorConfig";
import { useVocabIntl } from "../hooks/useVocabTranslation";

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <HiOutlineArrowUp />
    </components.DropdownIndicator>
  );
};

function LevelSelect(props: any) {
  const { getFormattedString } = useVocabIntl();

  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      components={{ DropdownIndicator }}
      placeholder={"Choisir"}
      noOptionsMessage={() => getFormattedString('no-options')}
      options={[]}
      {...props}
      styles={{
        control: (provided, state) => ({
          ...provided,
          borderRadius: "0.5rem",
          border: `2px solid ${apColorConfig.lightGray["600"]}`,
          background: apColorConfig.lightGray["500"]
        }),
      }}
    />
  );
}

export default LevelSelect;
